export function genDownloadUrl(record, suffix) {
  const baseName = record?.name.replace(/\s+/g, "").substring(0,30) || ""
  const url = record?.answerUrl || ''
  if (!baseName) { return url }

  const tag = suffix ? `-${suffix}` : ''
  const ext = url.substring(url.lastIndexOf(".")).toLowerCase()
  return `${url}?filename=${encodeURIComponent(baseName + tag + ext)}`
}